import { useContext } from 'react';

import { PermissionsContext } from '@/shared/features/permissions/context/permissions-context';
import { TUsePermissionCheck } from '@/shared/features/permissions/context/permissions-context.types';
import {
  TPermissionCheck,
  TPermissionCheckRule,
} from '@/shared/features/permissions/permission-check.types';
import {
  can,
  canAny,
} from '@/shared/features/permissions/utils/permission-matchers';

export const usePermissionCheck = (): TUsePermissionCheck => {
  const { model, isLoading, error, retry } = useContext(PermissionsContext);

  return {
    can: (actions, ids) => (model ? can(model, actions, ids) : true),
    canAny: (actions, ids) => (model ? canAny(model, actions, ids) : true),
    isLoading,
    error,
    retry,
  };
};

export const useHasPermission = (permission?: TPermissionCheck): boolean => {
  const { can, canAny } = usePermissionCheck();

  if (!permission) {
    return true;
  }

  const checkRule = (rule: TPermissionCheckRule): boolean =>
    rule.any ? canAny(rule.action, rule.ids) : can(rule.action, rule.ids);

  return Array.isArray(permission)
    ? permission.every(checkRule)
    : checkRule(permission);
};
